import './StarRating.css';
import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as IconStar } from '../../../public/images/svg/icon_star.svg';

const StarRating = ({ disabled = false, score = 0, onClick, className = '' }) => {
  const icons = [1, 2, 3, 4, 5].map((s) => {
    return (
      <button
        key={s}
        disabled={disabled}
        data-testid={`feedback-star-rating-${s}`}
        className="star-rating__icon rounded-sm focus-visible:outline focus-visible:outline-2 disabled:cursor-default disabled:opacity-50"
        onClick={() => onClick?.({ score: s })}
      >
        <IconStar className={`${score >= s ? 'fill-yellow-500' : 'fill-black'}`} />
      </button>
    );
  });

  return (
    <div data-testid="feedback-star-rating" className={`star-rating inline-flex ${className}`}>
      {icons}
    </div>
  );
};

StarRating.propTypes = {
  disabled: PropTypes.bool,
  score: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default StarRating;
